/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v20H2V2zm-2 2H4v16h16zm-7 12V8h3a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3zM7 8v4h2V8h2v8H9v-2H7v2H5V8zm8 6h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHd as Hd };
